import en from "./en.js";
import es from "./es.js";
import ptBR from "./pt-BR.js";
import type { SiteContent, SiteLocale } from "./types.js";

export type {
  ContractCopy,
  FaqCopy,
  FootCopy,
  HeroCopy,
  HowCopy,
  MetaCopy,
  NavCopy,
  PageContent,
  PanelCopy,
  PanelEvent,
  PlannerContent,
  PricingCopy,
  SiteContent,
  SiteLocale,
  SplitCopy,
  TrackId,
} from "./types.js";

export const SITE_LOCALES: readonly SiteLocale[] = ["pt-BR", "en", "es"];

export const CONTENT: Record<SiteLocale, SiteContent> = { "pt-BR": ptBR, en, es };

const PATHS: Record<SiteLocale, string> = { "pt-BR": "/", en: "/en/", es: "/es/" };

export function pathForLocale(locale: SiteLocale): string {
  return PATHS[locale];
}

export function localeFromPath(pathname: string): SiteLocale {
  const first = pathname.split("/").filter(Boolean)[0];
  return first === "en" || first === "es" ? first : "pt-BR";
}
